{
  "name": "shear",
  "doc": "A horizontal stretch and a vertical squeeze: every form is pulled sideways into streaks and flattened. Lines become horizons.",
  "cx": 0.5,
  "cy": 0.5,
  "zoom": 1.004,
  "zoomexp": 1.0,
  "rot": 0.0,
  "rotr": 0.0,
  "dx": 0,
  "dy": 0,
  "sx": 1.018,
  "sy": 0.99,
  "warp": 0,
  "warpScale": 4,
  "warpSpeed": 0.3,
  "decay": 0.955,
  "invert": 0,
  "hueShift": 0.003,
  "darkenCenter": 0.0,
  "wave": "LINE",
  "waveColor": 1,
  "shapes": 0,
  "energy": [
    0.45,
    0.9
  ]
}